import { useRouteMatch } from 'react-router-dom';

import { useIsConnect } from '@/components/ConnectApps/Common/routeHandlers';
import { useQueryParams } from '@/hooks/useQueryParams';

export const useSourceType = () => {
  const [query] = useQueryParams();
  const { params } = useRouteMatch<{
    subCategory: string;
  }>(['/search/:subCategory', '/:category/:source/:subCategory']) || {
    params: { subCategory: '' },
  };

  const isWebsite =
    params?.subCategory === 'rss_news' || query?.category_tab === 'rss_news';
  const isNeedlWeb = query?.search_type === 'needl_web';
  const isConnectPage = !!useIsConnect();
  const isCustomFeed = !!useRouteMatch('/custom-feed');

  return { isConnectPage, isWebsite, isNeedlWeb, isCustomFeed };
};
